<ng-container *transloco="let t; read: 'create-event-type-dialog'">
  <form class="create-event-type-dialog__form" [formGroup]="form" (ngSubmit)="save()">
    <p-messages severity="warn" [closable]="false">
      <ng-template pTemplate>
        <div class="ml-2">{{ t('warning') }}</div>
      </ng-template>
    </p-messages>

    <label class="create-event-type-dialog__field mt-4">
      <span class="create-event-type-dialog__label">{{ t('displayNameLabel') }}</span>
      <input class="w-full" pInputText type="text" [formControlName]="displayNameControlName" />
      <app-form-field-help [control]="getDisplayNameControl">
        <ng-container form-field-help-errors>
          <div *ngIf="getDisplayNameControl.hasError('required')">{{ t('displayNameRequired') }}</div>
          <div *ngIf="getDisplayNameControl.hasError('maxlength')">
            {{ t('displayNameMaxLength', { max: maxEventNameLength }) }}
          </div>
          <div *ngIf="getDisplayNameControl.hasError('notInList')">{{ t('displayNameUnique') }}</div>
        </ng-container>
      </app-form-field-help>
    </label>

    <p-messages *ngIf="saveFailed" severity="error" [closable]="false">
      <ng-template pTemplate>
        <div class="ml-2">{{ t('saveFailed') }}</div>
      </ng-template>
    </p-messages>

    <div class="flex justify-content-end gap-2 mt-4">
      <p-button
        styleClass="p-button-text"
        type="button"
        [disabled]="isSaving"
        [label]="t('cancelButtonLabel')"
        (onClick)="close()"
      ></p-button>
      <p-button
        icon="pi pi-check"
        type="submit"
        [disabled]="!isValid() || isSaving"
        [label]="t('saveButtonLabel')"
        [loading]="isSaving"
      ></p-button>
    </div>
  </form>
</ng-container>
